var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2 51.33H6.8v1.07h42.4v-1.07z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53 3.33l-2.4 25.6 13.74 1.47L36.4 4.8 22.53 3.33z",
    fill: "#A7E2F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53 3.33l-2.4 25.6 13.74 1.47L36.4 4.8 22.53 3.33zM32 5.47a3.8 3.8 0 002.8 4L33.2 25.6c-.93 0-1.73.4-2.4 1.07a4.2 4.2 0 00-1.2 2.26l-5.07-.53a4.8 4.8 0 00-.8-2.67c-.53-.8-1.2-1.2-2.13-1.46l1.6-16a3.97 3.97 0 003.6-3.47l5.2.67z",
    fill: "#77D9F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13 12.8l8.4 24.4 13.2-4.4L21.2 8.4 8.13 12.8z",
    fill: "#A7E2F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.13 12.8l8.4 24.4 13.2-4.4L21.2 8.4 8.13 12.8zm9.34-2c.26.93.8 1.6 1.6 2 .8.53 1.73.67 2.66.53l5.47 15.34a3.6 3.6 0 00-1.87 4.53l-5.06 1.73c-.27-.93-.8-1.6-1.6-2A3.75 3.75 0 0016 32.4l-5.33-15.33a3.6 3.6 0 001.86-4.54l4.94-1.73z",
    fill: "#77D9F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.67 25.07c1.2.13 2.26-.8 2.4-2 .13-1.2-.67-2.4-2-2.54-1.2-.13-2.27.8-2.4 2-.27 1.2.53 2.27 1.73 2.54h.27z",
    fill: "#77D9F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.27 37.87L49.2 15.33 37.07 9.47 26 32l12.27 5.87z",
    fill: "#A7E2F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.27 37.87L49.2 15.33 37.07 9.47 26 32l12.27 5.87zm-7.87-4.94c.4-.8.4-1.73.13-2.53a3.02 3.02 0 00-1.46-2.13L36 14.13c.8.27 1.73.27 2.53-.13.8-.4 1.47-1.07 1.87-1.87l4.53 2.27a3.39 3.39 0 001.34 4.53L39.33 33.2a3.35 3.35 0 00-2.53.13c-.8.27-1.47.94-1.87 1.74l-4.53-2.14z",
    fill: "#77D9F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.47 25.73c1.2.14 2.13-.8 2.26-2 .14-1.2-.8-2.13-2-2.26-1.2-.14-2.13.8-2.26 2-.14 1.2.8 2.13 2 2.26z",
    fill: "#77D9F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.93 52.13H9.2V24.67h35.6c.67-.14 1.2.4 1.33 1.06V50.8c0 .27-.13.67-.4.8-.13.4-.4.53-.8.53z",
    fill: "#485CC7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.93 34.93h9.87v6.94h-9.87c-1.2 0-2.13-.94-2.26-2.14v-2.66c-.14-1.07.8-2 1.86-2.14h.4z",
    fill: "#37517E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18c1.2.13 2.13-.8 2.27-2 .13-1.2-.8-2.13-2-2.27-1.2-.13-2.14.8-2.27 2-.13 1.2.93 2.14 2 2.27z",
    fill: "#77D9F7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 6.8,
    y1: 51.87,
    x2: 49.2,
    y2: 51.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaving);
export default __webpack_public_path__ + "static/media/saving.f1cc85f8fe8d89df9337cc739a0ce7a4.svg";
export { ForwardRef as ReactComponent };